import * as Yup from 'yup';

export const CandidateCompensationSchema = Yup.object().shape({
  totalCompensation: Yup.number()
    .required('Total Compensation value  is required.')
    .typeError('Total Compensation value should be a number'),
  fixedCompensation: Yup.number()
    // .required('This value is required.')
    .typeError('This value should be a number')
    .nullable(),
  variableCompensation: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  incentive: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  bonus: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  otherBenefits: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  epos: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  fixedCtcExpectation: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  expectedCTC: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  secondYearIncrement: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
  firstYearIncrement: Yup.number()
    .typeError('This value should be a number')
    .nullable(),
});